/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/noInvoiceDetails"/>
import { FlexLayout, Text, ImageRocketRocketlaunch  } from '@medius/ui-controls';
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';
import * as React from 'react';

export const NoInvoiceDetails = () => {
    return (
        <FlexLayout
            direction='column'
            horizontalAlignment='center'
            verticalAlignment='center'
            width='fill'
            height='fill'
        >
            <ImageRocketRocketlaunch width={150}/>
            <Text variant='heading1'>
                {translate("#PurchaseToPay/noInvoiceDetails")}
            </Text>
            <Text variant='body'>
                {translate("#PurchaseToPay/noInvoiceDetails/description")}
            </Text>
        </FlexLayout>
    );
};